import { QueryResult, useQuery } from '@apollo/client'
import {
  CompanyManagerDashboardPartialVisibilityQuery,
  CompanyManagerDashboardPartialVisibilityQueryVariables,
  RoleName,
} from '../../../types'

import { COMPANY_MANAGER_DASHBOARD_PARTIAL_VISIBILITY } from '../Queries'

const partialVisibilityDashboardQueryOptions = {
  fetchPolicy: 'cache-first' as const,
}

const shouldSkipPartialVisibilityQuery = (userDashboardRoles: RoleName[]): boolean =>
  userDashboardRoles.includes(RoleName.BusinessPartner) || userDashboardRoles.includes(RoleName.CompanyManager)

export const useCompanyManagerDashboardPartialVisibility = (
  companyId: string,
  userDashboardRoles: RoleName[],
): QueryResult<CompanyManagerDashboardPartialVisibilityQuery, CompanyManagerDashboardPartialVisibilityQueryVariables> => {
  return useQuery<CompanyManagerDashboardPartialVisibilityQuery, CompanyManagerDashboardPartialVisibilityQueryVariables>(
    COMPANY_MANAGER_DASHBOARD_PARTIAL_VISIBILITY,
    {
      variables: { companyId, userDashboardRoles },
      skip: shouldSkipPartialVisibilityQuery(userDashboardRoles),
      ...partialVisibilityDashboardQueryOptions,
    },
  )
}
